import { useState, useLayoutEffect } from 'react';

export default function() {
    var initialWidth = window && window.innerWidth ? window.innerWidth : 0
    var initialHeight = window && window.innerHeight ? window.innerHeight : 0
    const [size, setSize] = useState([initialWidth, initialHeight]);
    useLayoutEffect(() => {
      function updateSize() {
        setSize([window.innerWidth, window.innerHeight]);
      }
      window.addEventListener('resize', updateSize);
      updateSize();
      return () => window.removeEventListener('resize', updateSize);
    }, []);
    return size;
}